import React, { useEffect, useState } from "react";
import loadingImg from "../images/loading.svg";

export const PageLoader: React.FC = () => {
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShowLoading(true);
    }, 50)
  }, []);
  return (
    <div className="flex h-11/12 w-full items-center justify-center">
      <div className="h-30 w-30">
        <img className={showLoading ? "visible" : "invisible"} src={loadingImg} alt="Loading..." />
      </div>
    </div>
  );
};